import React from "react";
import withStyles from "react-jss";

const styles = () => ({
	root: {
		position: "fixed",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 0,
		backgroundColor: "rgba(43, 29, 92, 0.3)",
	},
});

const Fade = ({ classes }) => <div className={classes.root} />;

export default withStyles(styles)(Fade);

export { Fade as __Fade };
